
export default function Ecosystem() {
  const partners = [
    { name: '平台方', logo: 'ri-store-3-line' },
    { name: '服务机构', logo: 'ri-service-line' },
    { name: '企业客户', logo: 'ri-building-line' },
    { name: '技术伙伴', logo: 'ri-code-box-line' },
    { name: '金融机构', logo: 'ri-bank-line' },
    { name: '物流服务', logo: 'ri-truck-line' },
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-br from-[#F0FDFA] via-white to-[#FFF7ED]">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="text-4xl font-bold text-gray-900 text-center mb-4">
          开放式生态协同
        </h2>
        <p className="text-center text-gray-500 mb-16 max-w-[700px] mx-auto">
          通过接口对接与流程协同，
          我们与平台方、服务机构及企业客户构建合规管理生态。
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="aspect-square rounded-xl border border-gray-100 bg-white hover:border-[#14B8A6] hover:shadow-md transition-all group cursor-pointer flex flex-col items-center justify-center gap-3"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-50 group-hover:bg-[#14B8A6]/10 transition-all">
                <i className={`${partner.logo} text-2xl text-gray-400 group-hover:text-[#14B8A6] transition-all`}></i>
              </div>
              <span className="text-sm text-gray-500 group-hover:text-gray-800 transition-all">
                {partner.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
